import { useEffect, useState } from "react";
import { io, type Socket } from "socket.io-client";

const SOCKET_URL = import.meta.env.PROD ? window.location.origin : "http://localhost:3002";

export function useSocket() {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [connected, setConnected] = useState(false);
  const [reconnecting, setReconnecting] = useState(false);
  const [connectionError, setConnectionError] = useState<string | null>(null);

  useEffect(() => {
    const instance = io(SOCKET_URL, {
      path: "/socket.io",
      transports: ["websocket", "polling"],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1_000,
      reconnectionDelayMax: 5_000,
      timeout: 20_000,
    });

    setSocket(instance);

    instance.on("connect", () => {
      setConnected(true);
      setReconnecting(false);
      setConnectionError(null);
    });
    instance.on("disconnect", (reason) => {
      setConnected(false);
      if (reason !== "io client disconnect") setReconnecting(true);
    });
    instance.on("reconnect_attempt", () => setReconnecting(true));
    instance.on("connect_error", (err) => {
      setConnectionError(err.message);
      setConnected(false);
      setReconnecting(true);
    });

    return () => {
      instance.disconnect();
      setSocket(null);
      setConnected(false);
      setReconnecting(false);
    };
  }, []);

  return { socket, connected, reconnecting, connectionError };
};
